import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, Select } from 'components';
import { ExcludedPlaceService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals } from 'utils';
import { CloseIcon } from 'assets/icons';
import { PinIcon, RemoveIcon, AddWhiteIcon, PinSmallIcon } from 'assets/icons';

interface Props {
	title?: string;
	onClose?: any;
	item?: any;
}

// @ts-ignore
const google = window.google;

class CreatePlace extends React.Component<Props> {

	state = {
		form: {
			name: '',
			latitude: '10.48801',
			longitude: '-66.87919'
		},
		error_map: false,
		polygon: null,
		map: null,
		marker: null,
		polygon_coords: [],
		markers: []
	}

	async componentDidMount() {
		if (this.props.item) {
			await this.setState({
				form: {
					latitude: this.props.item?.latitude || '10.48801',
					longitude: this.props.item?.longitude || '-66.87919',
					name: this.props.item?.name || '',
				},
				polygon_coords: this.props.item?.coords.map((i: any) => {
					return {
						latitude: parseFloat(i.latitude),
						longitude: parseFloat(i.longitude)
					}
				})
			});
		}

		this.setMap();
	}

	submit = async (e: any) => {
		e.preventDefault();
		if (this.props.item != null) {
			await ExcludedPlaceService.admin.update({
				place_id: this.props.item?.id,
				...this.state.form,
				coords: JSON.stringify(this.state.polygon_coords)
			});
			Globals.showSuccess("Se ha modificado el lugar excluido correctamente");
			this.props.onClose();
		}
		else {
			await ExcludedPlaceService.admin.create({
				...this.state.form,
				coords: JSON.stringify(this.state.polygon_coords)
			});
			Globals.showSuccess("Se ha creado el lugar excluido correctamente");
			this.props.onClose();
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	setMap = async () => {
		const center = new google.maps.LatLng(this.state.form?.latitude || '10.48801',this.state.form?.longitude || '-66.87919');

		const map = new google.maps.Map(document.getElementById('map'), {
	      zoom: 13,
	      center,
	      draggable: true,
	      zoomControl: true,
	      streetViewControl: false,
	      fullscreenControl: false,
	      scaleControl: false,
	      rotateControl: false
	    });

	    const polygon = new google.maps.Polygon({
	      paths: this.state.polygon_coords.map((i: any) => {
    		return {
    			lat: i.latitude,
    			lng: i.longitude
    		}
	      }),
		  strokeColor: "#88c440",
		  strokeOpacity: 0.8,
		  strokeWeight: 2,
		  fillColor: "#88c440",
		  fillOpacity: 0.35,
		  map
	    });

	    await this.setState({
			map,
			polygon
	    });

	    google.maps.event.addListener(map,'click',async (event: any) => {
	    	let markers: any = this.state.markers;
	    	const marker = new google.maps.Marker({
		      position: new google.maps.LatLng(event.latLng.lat() || '10.48801',event.latLng.lng() || '-66.87919'),
		      map,
		      title: '',
		      animation: google.maps.Animation.DROP,
		      draggable: true,
		      icon: PinSmallIcon
		    });
		    markers.push(marker);
	    	let polygon_coords: any = [...this.state.polygon_coords];
	    	polygon_coords.push({
	    		latitude: event.latLng.lat(),
	    		longitude: event.latLng.lng()
	    	})
	    	await this.setState({
	    		polygon_coords,
	    		markers
	    	});
	    	this.updatePolygon();
	    });

	    const input = document.getElementById('location-input');
        const autocomplete = new google.maps.places.Autocomplete(input, {
        	componentRestrictions: {
        		country: "ve"
        	}
        });
        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            var place = autocomplete.getPlace();
            const latitude = place.geometry.location.lat();
            const longitude = place.geometry.location.lng();
            this.setState({
            	form: {
            		...this.state.form,
            		latitude,
            		longitude
            	}
            });
            // @ts-ignore
            document.querySelector('#location-input').value = '';
            const center = new google.maps.LatLng(latitude,longitude);
            map.setCenter(center);
        });
        google.maps.event.addListener(map,'dragend',async (event: any) => {
        	this.setState({
        		form: {
        			...this.state.form,
	        		latitude: map.getCenter().lat(),
	        		longitude: map.getCenter().lng()
        		}
        	});
        });

		for (let i = 0; i < this.props.item?.coords.length; i++) {
			const coord = this.props.item?.coords[i];

			let markers: any = this.state.markers;
	    	const marker = new google.maps.Marker({
		      position: new google.maps.LatLng(coord?.latitude || '10.48801',coord?.longitude || '-66.87919'),
		      map: this.state.map,
		      title: '',
		      animation: google.maps.Animation.DROP,
		      draggable: true,
		      icon: PinSmallIcon
		    });
		    markers.push(marker);

		    this.setState({
		    	markers
		    });
		}
	}

	reset = async () => {
		let markers = [...this.state.markers];
		for (let i = 0; i < markers.length; i++) {
			// @ts-ignore
			markers[i].setMap(null);
		}
		await this.setState({
			polygon_coords: [],
			markers: []
		});
		this.updatePolygon();
	}

	updatePolygon = () => {
		// @ts-ignore
		this.state.polygon.setPath(this.state.polygon_coords.map((i: any) => {
    		return {
    			lat: i.latitude,
    			lng: i.longitude
    		}
    	}));
	}
	
	render() {
		const { error_map } = this.state;

		return (
			<div id="modal-create-place">
				<form onSubmit={ this.submit }>
					<div className="row-inputs">
						<Input
							color="white"
							value={ this.state.form.name }
							name="name" 
							label="Nombre del lugar"
							onChange={ this.change } />

						{
							!error_map && (
								<React.Fragment>
									<label className="location-input-label">Indicar punto en el mapa</label>
									<input type="text" placeholder="Buscar dirección Google Mapas" id="location-input" />
								</React.Fragment>
							)
						}

						{
							!error_map && (
								<div id="map"></div>
							)
						}

						{
							error_map && (
								<div className="location-permission">
									<p>Para el correcto funcionamiento de la página debe permitir el acceso a su ubicación</p>
								</div>
							)
						}

						<div className="row">
							<div className="col-md-6">
								<button className="btn-reset" type="button" onClick={ () => this.reset() }>
									Reiniciar
								</button>
							</div>
							<div className="col-md-6">
								<p className="note">Haga 3 o más clicks para crear el área que delimita la zona</p>
							</div>
						</div>
					</div>
					<div className="text-center">
						<Button type="submit" className="btn-save">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default CreatePlace;